export default function MemberRulesCompareCtrl($rootScope, UserService, $mdSidenav, $timeout, $scope) {

  $timeout(() => $mdSidenav('left').close())
    .finally(() => { $rootScope.$broadcast('sidenav:forceClose', 'left'); });

  $scope.$on('$destroy', () => {
    // re-enable the normal lock behavior
    $rootScope.$broadcast('sidenav:forceOpen', 'left');

  });

}
